import { useDateFormatting } from "@/composables/useDateFormatting";
import { getUserById } from "@/helpers/userHelper";
import { DateTime } from "luxon";

export default {
  name: "CommentChat",
  props: {
    comments: {
      type: Array
    },
    currentUserId: {
      type: String
    }
  },
  data: () => ({
    authors: []
  }),
  setup() {
    const { getNiceDateTime } = useDateFormatting();
    return {
      getNiceDateTime
    };
  },
  async mounted() {
    if (this.comments?.length > 0) {
      await this.fetchAuthors();
    }
  },
  watch: {
    async comments(comments) {
      await this.fetchAuthors(comments);
    }
  },
  computed: {
    sortedComments() {
      return this.comments?.sort((a, b) => {
        return DateTime.fromISO(a?.sentAt) + DateTime.fromISO(b?.sentAt);
      });
    }
  },
  methods: {
    async fetchAuthors() {
      const uniqueAuthorIds = [
        ...new Set(this.comments.map(c => c.author).filter(id => id))
      ];

      for (const id of uniqueAuthorIds) {
        try {
          const author = await getUserById(id);
          this.authors.push(author);
        } catch (error) {
          console.error(`Error fetching author ${id}:`, error);
        }
      }
    },

    getCommentAuthor(comment) {
      const author = this.authors.find(a => a._id === comment.author);

      if (author?.first_name || author?.last_name) {
        return [author.first_name, author.last_name]
          .filter(Boolean)
          .join(" ")
          .trim();
      }

      return "Anonymer Benutzer";
    }
  }
};
